import { render, staticRenderFns } from "./Lock.vue?vue&type=template&id=0950f344&scoped=true"
var script = {}
import style0 from "./Lock.vue?vue&type=style&index=0&id=0950f344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950f344",
  null
  
)

export default component.exports